Object.defineProperty(exports, "__esModule", {
  value: true
});

var _breakpoints, _responsive;

exports.matchesProgressive = matchesProgressive;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var unit = exports.unit = 8;

var BREAKPOINT_NAMES = exports.BREAKPOINT_NAMES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};

var PROGRESSIVE_BREAKPOINT_NAMES = exports.PROGRESSIVE_BREAKPOINT_NAMES = {
  MEDIUM_AND_ABOVE: 'mediumAndAbove',
  LARGE_AND_ABOVE: 'largeAndAbove'
};

var breakpoints = exports.breakpoints = (_breakpoints = {}, _defineProperty(_breakpoints, BREAKPOINT_NAMES.LARGE, 1128), _defineProperty(_breakpoints, BREAKPOINT_NAMES.MEDIUM, 744), _defineProperty(_breakpoints, BREAKPOINT_NAMES.SMALL, 327), _breakpoints);

var responsive = exports.responsive = (_responsive = {}, _defineProperty(_responsive, BREAKPOINT_NAMES.LARGE, '@media (min-width: ' + String(breakpoints[BREAKPOINT_NAMES.LARGE]) + 'px)'), _defineProperty(_responsive, BREAKPOINT_NAMES.MEDIUM, '@media (max-width: ' + (breakpoints[BREAKPOINT_NAMES.LARGE] - 1) + 'px)'), _defineProperty(_responsive, BREAKPOINT_NAMES.SMALL, '@media (max-width: ' + (breakpoints[BREAKPOINT_NAMES.MEDIUM] - 1) + 'px)'), _defineProperty(_responsive, PROGRESSIVE_BREAKPOINT_NAMES.MEDIUM_AND_ABOVE, '@media (min-width: ' + String(breakpoints[BREAKPOINT_NAMES.MEDIUM]) + 'px)'), _defineProperty(_responsive, PROGRESSIVE_BREAKPOINT_NAMES.LARGE_AND_ABOVE, '@media (min-width: ' + String(breakpoints[BREAKPOINT_NAMES.LARGE]) + 'px)'), _responsive);

function matchesProgressive(breakpoint, progressiveBreakpoint) {
  if (breakpoint === BREAKPOINT_NAMES.SMALL) {
    return false;
  }
  if (breakpoint === BREAKPOINT_NAMES.MEDIUM) {
    if (progressiveBreakpoint === PROGRESSIVE_BREAKPOINT_NAMES.MEDIUM_AND_ABOVE) {
      return true;
    }
    return false;
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/size.js
// module id = 56
// module chunks = 168707334958949